import { render, staticRenderFns } from "./CButtons.vue?vue&type=template&id=64acea6f&scoped=true"
import script from "./CButtons.vue?vue&type=script&lang=js"
export * from "./CButtons.vue?vue&type=script&lang=js"
import style0 from "./CButtons.vue?vue&type=style&index=0&id=64acea6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acea6f",
  null
  
)

export default component.exports